import { Box, Typography } from "@mui/material";
import Navbar from "../../../components/Navbar";
import Video from "../../../components/Video";

const Hero = () => {
  return (
    <>
      <Navbar />
      {/* Video Hero Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Video Background */}
        <Box
          component="video"
          autoPlay
          muted
          loop
          playsInline
          poster="/videos/around-us.jpg"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        >
          <source src="/videos/around-us.webm" type="video/webm" />
          <img
            src="/videos/around-us.jpg"
            alt="Around us background"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>

        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 0,
          }}
        />

        {/* Content */}
        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            textAlign: "center",
            color: "white",
            px: 2,
            maxWidth: "1200px",
          }}
        >
          <Typography
            color="rgba(255, 255, 255, 0.8)"
            textAlign="center"
            sx={{
              fontSize: { xs: "0.9rem", sm: "1rem" },
              fontWeight: 600,
              letterSpacing: 2,
              textTransform: "uppercase",
              mb: 2,
            }}
            data-aos="fade-up"
          >
            Around Us
          </Typography>

          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "3rem", sm: "4rem", md: "5rem", lg: "6rem" },
              fontWeight: 700,
              lineHeight: 1.1,
              mb: 3,
            }}
            data-aos="fade-up"
            data-aos-delay={200}
          >
            See what's going on
            around you
          </Typography>
        </Box>
      </Box>

      {/* Previous Hero Section (Hidden) */}
      <Box sx={{ display: "none" }}>
        <Box
          borderRadius={6}
          py={4}
          pb={{ xs: 2, sm: 6 }}
          boxSizing="border-box"
          bgcolor="#E4DD60"
          justifyContent="end"
        >
          <Navbar />
          <Box maxWidth={800} m="auto" mt={16} data-aos="fade-up" width={"90%"}>
            <Typography color="#00000070" textAlign="center" mt={1}>
              AROUND US
            </Typography>
            <Typography
              variant={"h2"}
              typography={{ xs: "h3", sm: "h2" }}
              color="#000000"
              textAlign="center"
              mt={1}
            >
              See what's happening around you
            </Typography>
          </Box>

          <Video path="/videos/around-us" />
        </Box>
      </Box>
    </>
  );
};

export default Hero;
